import { render, staticRenderFns } from "./sessionlist.vue?vue&type=template&id=4656ab39&"
import script from "./sessionlist.vue?vue&type=script&lang=ts&"
export * from "./sessionlist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports